export class InvoiceBankAccountModel {
  public id: number;
  public activated: boolean = null;
  public company: string = null;
  public bankName: string = null;
  public accountNumber: string = null;
  public iban: string = null;
  public swift: string = null;
  public label: string = null;
  public collectionAccount: boolean = null;
  public address: string = null;
  public currency: string = null;
  public miloCode: string = null;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: InvoiceBankAccountModel[] = [];
    jsons.forEach(json => {
      refs.push(new InvoiceBankAccountModel().fromJSON(json));
    });
    return refs;
  }
}
